export enum ROUTERGO {
  FBUCLUES = '/fbu/salesClue/view', // 谷仓：线索
  FBUSIGN = '/fbu/contract/view', // 谷仓：签约
  FBUSUCCESS = '/fbu/clients/view', // 谷仓：成交
  FBUPOTENTIAL = '/fbu/potential/view', // 谷仓：潜在

  OFBUCLUES = '/ofbu/salesClue/view', // 谷仓海外：线索
  OFBUSIGN = '/ofbu/contract/view', // 谷仓海外：签约
  OFBUSUCCESS = '/ofbu/clients/view', // 谷仓海外：成交
  OFBUPOTENTIAL = '/ofbu/potential/view', // 谷仓海外：潜在

  LBUCLUES = '/lbu/salesClue/view', // 谷仓：线索
  LBUSUCCESS = '/lbu/clients/view', // 云途：成交
  LBUPOTENTIAL = '/lbu/potential/view' // 云途：潜在
}
export enum ROUTERType {
  FBUCLUESType = 1, // 谷仓：线索
  FBUPOTENTIALType = 2, // 谷仓：潜在
  FBUSIGNType = 3, // 谷仓：签约
  FBUSUCCESSType = 4, // 谷仓：成交

  LBUCLUESType = 1, // 云途：线索
  LBUPOTENTIALType = 2, // 云途：潜在
  LBUSUCCESSType = 4 // 云途：成交
}
